export const button = {
  save: 'Сохранить',
  add: 'Добавить',
  yes: 'Да',
  no: 'Нет',
  update: 'Обновить',
  change: 'Изменить',
  cancel: 'Отменить',
  confirm: 'Подтвердить',
  upload: 'Загрузить Файл',
  import: 'Импортировать файл',
  back: 'Назад',
  close: 'Закрыть',
  request: 'Запросить',
  next: 'Далее',
  download: 'Скачать',
  ok: 'OK',
};
